import { Box } from '@mui/material'

const PerplexityLogo = ({ size = 24 }: { size?: number }) => {
  const sx = {
    height: `${size}px`,
    width: `${size}px`,

    '& img': {
      objectFit: 'cover',
      height: '100%',
      width: '100%',
    },
  }
  return (
    <Box sx={sx}>
      <Box
        component="img"
        src="/perplexity.png"
      />
    </Box>
  )
}

export default PerplexityLogo
